//@ vendors
const trim = require('lodash/string/trim');
const get = require('lodash/object/get');
const { cloneDeep } = require('lodash');
//@ helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { APIPost, APIGet, APIPostMb } = require('utilities/APIRequestHelper');
const transfersHelper = require('utilities/transfersHelper');
const { getSessionId, getWidgetData } = require('utilities/nuDataUtils');
const { formatTextApi, getLanguage, formatText } = require('core/i18n').i18n;

//@ actions
const signaturePatternActions = require('actions/signaturePattern');
const { requestEmitedTransfersDetails } = require('actions/emitedTransfersDetails');
const { requestBeneficiaries } = require('actions/beneficiaries');
const addBeneficiaryActions = require('actions/addBeneficiary');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');

//@ constants
const actionTypes = require('constants/actionTypes');
const {
    DATE_FORMAT_API,
    PERIODICITY_CONSTANTLY,
    PERIODICITY_DATE,
    PERIODICITY_COUNT,
    PERIODICITY_MONTHLY,
    PERIODICITY_QUARTERLY,
    PERIODICITY_BIANNUAL,
    BENEFICIARY_TYPE_EXISTING,
    API_ENTERPRISE_NUMBER,
    INTERVENER_TYPE_TITULAR,
    SEPA_INTERNATIONAL,
    SEPA_NATIONAL,
    NONE_SEPA,
    BENEFICIARY_TYPE_NEW,
    BENEFICIARY_TYPE_NGO,
    BENEFICIARY_IS_RESIDENT,
    BENEFICIARY_IS_NOT_RESIDENT,
    DEFAULT_COUNTRY,
    BENEFICIARY_BANK_OPTION_NAME,
    EURO_TEXT,
    TRANSFER_COSTS_BENEFICIARY,
    TRANSFER_COSTS_BENEFICIARY_TEXT,
    TRANSFER_COSTS_SENDER,
    TRANSFER_COSTS_SENDER_TEXT,
    TRANSFER_COSTS_SHARED,
    UNEXPECTED_ERROR,
    HYPHEN
} = require('constants/index');
const {
    IMMEDIATE_TRANSFER_PRODUCT_ALIAS,
} = require('constants/transferProduct');
const { DEFAULT_TRANSLATION_TEXT } = require('constants/translations');
const {
    TRANSFERS_SECURITY_WARNING,
} = require('constants/flagBasedFeatures');
// @ contact-center
const {
    CC_PERIODICITY_DAILY,
    CC_PERIODICITY_WEEKLY,
    CC_PERIODICITY_CUSTOM,
    CC_PERIODICITY_RANGE_SPECIFICATION_DAYS,
    CC_TRANSFER_TYPE_ORDINARY,
    CC_TRANSFER_TYPE_CODE_ORDINARY,
    CC_TRANSFER_TYPE_CODE_ORDINARY_EMISION_SEPA_INTERNATIONAL,
    CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL,
    CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL,
} = require('constants/contactCenter/transfers');

const {
    TRANSFER_SET_TRANSFER_TYPE,
    TRANSFER_SET_WEEK_DAY,
    TRANSFER_CUSTOM_REPEAT_ADD_MONTH_DAY,
    TRANSFER_CUSTOM_REPEAT_REMOVE_MONTH_DAY,
    TRANSFER_CUSTOM_REPEAT_SET_MONTH_DAY,
    TRANSFER_SET_PERIODICITY_RANGE_QUANTITY,
    TRANSFER_SET_PERIODICITY_RANGE_DESCRIPTION,
    TRANSFER_SET_PERIODICITY_RANGE_SPECIFICATION,
    TRANSFER_RESET_WEEK_DAY
} = require('constants/contactCenter/actionTypes');

const setIbanOnCountryChange = (ibanIsDirty) => ({
    type: actionTypes.TRANSFER_BENEFICIARY_SET_IBAN_ON_COUNTRY_CHANGE,
    ibanIsDirty
});

function reset() {
    return {
        type: actionTypes.TRANSFER_RESET
    };
}

function setWeekDay(day) {
    return {
        type: TRANSFER_SET_WEEK_DAY,
        payload: {
            day
        }
    }
}

function setPeriodicityRangeQuantity(rangeQuantity, date){
    return {
        type: TRANSFER_SET_PERIODICITY_RANGE_QUANTITY,
        payload: {
            rangeQuantity,
            estimatedDate: date,
        }
    }
}

function accountLimitModalToggle() {
    return {
        type: actionTypes.TRANSFER_ACCOUNT_LIMIT_MODAL_TOGGLE
    };
}

function addCustomizedMonthDay(day) {
    return {
        type: TRANSFER_CUSTOM_REPEAT_ADD_MONTH_DAY,
        payload: {
            day
        }
    }
}

function removeCustomizedMonthDay(day) {
    return {
        type: TRANSFER_CUSTOM_REPEAT_REMOVE_MONTH_DAY,
        payload: {
            day
        }
    }
}

function setCustomSelectedMonthDay(day) {
    return {
        type: TRANSFER_CUSTOM_REPEAT_SET_MONTH_DAY,
        payload: {
            day
        }
    }
}

function setPeriodicityRangeDescription(rangeDescription){
    return {
        type: TRANSFER_SET_PERIODICITY_RANGE_DESCRIPTION,
        payload: {
            rangeDescription
        }
    }
}

function setPeriodicityRangeSpecification(rangeSpecified){
    return {
        type: TRANSFER_SET_PERIODICITY_RANGE_SPECIFICATION,
        payload: {
            rangeSpecified
        }
    }
}

function isFetching(data) {
    return {
        type: actionTypes.TRANSFER_IS_FETCHING,
        payload: {
            data
        }
    };
}

function setVisibleStep(data) {
    return {
        type: actionTypes.TRANSFER_SET_VISIBLE_STEP,
        payload: {
            data
        }
    };
}

function handlePeriodicityEnabled(evt) {
    return {
        type: actionTypes.TRANSFER_SET_PERIODICITY_ENABLED,
        payload: {
            enabled: evt.target.checked
        }
    };
}

function handlePeriodicityRange(range) {
    return {
        type: actionTypes.TRANSFER_SET_PERIODICITY_RANGE,
        payload: {
            range
        }
    };
}

function handleTreatmentNonWorkableDay(flag) {
    return {
        type: actionTypes.TRANSFER_SET_TREATMENT_NON_WORKABLE_DAY,
        payload: {
            flag
        }
    };
}

function setNotDeductibleNGOMessage(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_NOT_DEDUCTIBLE_MESSAGE,
        payload: {
            showMessage: value
        }
    };
}

const handleTransferCostsChange = costs => ({
    type: actionTypes.TRANSFER_SET_COSTS,
    payload: {
        costs
    }
});

const handleChangeTransferType = value => ({
    type: TRANSFER_SET_TRANSFER_TYPE,
    payload: {
        value
    }
});

const handleSetNGOValidity = isValid => ({
    type: actionTypes.TRANSFER_SET_NGO_VALIDITY,
    payload: {
        isValid
    }
});

function handlePeriodicityType(type) {
    return {
        type: actionTypes.TRANSFER_SET_PERIODICITY_TYPE,
        payload: {
            type
        }
    };
}

function handlePeriodicityDate(date) {
    return {
        type: actionTypes.TRANSFER_SET_PERIODICITY_DATE,
        payload: {
            date
        }
    };
}

function handlePeriodicityCount(count, date) {
    return {
        type: actionTypes.TRANSFER_SET_PERIODICITY_COUNT,
        payload: {
            count,
            estimatedDate: date
        }
    };
}

function setEmitter(emitter = '') {
    return {
        type: actionTypes.TRANSFER_SET_EMITTER,
        payload: {
            emitter: emitter
        }
    };
}

function loadOldEmitter(emitter = '') {
    return {
        type: actionTypes.TRANSFER_LOAD_OLD_EMITTER,
        payload: {
            emitter: emitter
        }
    };
}

// if the fromAccount was not chosen by the user in the accounts dropdown
// we shouldn't mark the form as "in progress". The flag wasChosenInForm is used
// to indicate that difference
function setFromAccount(
    amount = '',
    currency = '',
    accountId = '',
    isInitialAccount = false,
    iban = '',
    accountOriginSubType = '',
    accountOriginType = ''
) {
    return {
        type: actionTypes.TRANSFER_FROM_ACCOUNT,
        payload: {
            amount,
            currency,
            accountId,
            isInitialAccount,
            iban,
            accountOriginSubType,
            accountOriginType
        }
    };
}

function setBeneficiary(id = '', currency, isSepa, iban, name) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_EXISTING,
        payload: {
            id,
            currency,
            isSepa,
            iban,
            name,
        }
    };
}

function setEmailNotification(email, isValid) {
    return {
        type: actionTypes.TRANSFER_SET_EMAIL_NOTIFICATION,
        payload: {
            email,
            isValid
        }
    };
}

function setBeneficiaryName(value) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_NAME,
        payload: {
            name: value
        }
    };
}

function setBeneficiaryAlias(value, isValid) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_ALIAS,
        payload: {
            alias: value,
            isValid
        }
    };
}

function setBeneficiaryIban(iban, isValid) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_IBAN,
        payload: {
            iban,
            ibanIsDirty: true,
            isValid
        }
    };
}

function setBeneficiaryBic(bic, isValid) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_BIC,
        payload: {
            bic,
            isValid
        }
    };
}

function setBeneficiaryAccountNumber(value, isValid) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_ACCOUNT_NUMBER,
        payload: {
            isValid,
            accountNumber: value
        }
    };
}

function handleAddBeneficiary(evt) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_ADD_AGENDA,
        payload: {
            enabled: evt.target.checked
        }
    };
}

function handleBeneficiaryType(value) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_TYPE,
        payload: {
            type: value
        }
    };
}

function handleBeneficiaryCountry(country) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_COUNTRY,
        payload: {
            country
        }
    };
}

function handleBeneficiaryBankOption(option) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_BANK_OPTION,
        payload: {
            option
        }
    };
}

function setBeneficiaryBankName(value) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_BANK_NAME,
        payload: {
            name: value
        }
    };
}

function setBeneficiaryBankAddress(value) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_BANK_ADDRESS,
        payload: {
            address: value
        }
    };
}

function setBeneficiaryBankCity(value) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_BANK_CITY,
        payload: {
            city: value
        }
    };
}

function setBeneficiaryAddress(value) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_ADDRESS,
        payload: {
            address: value
        }
    };
}

function setBeneficiaryCity(value) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_CITY,
        payload: {
            city: value
        }
    };
}

function handleCurrency(currency) {
    return {
        type: actionTypes.TRANSFER_BENEFICIARY_CURRENCY,
        payload: {
            currency: currency.value
        }
    };
}

function setAmount(amount, maxTransferLimit=null) {
    return {
        type: actionTypes.TRANSFER_AMOUNT,
        payload: {
            amount,
            maxTransferLimit
        }
    };
}

function setConcept(concept) {
    return {
        type: actionTypes.TRANSFER_CONCEPT,
        payload: {
            concept
        }
    };
}

function setDate(date) {
    return {
        type: actionTypes.TRANSFER_DATE,
        payload: {
            date
        }
    };
}

function setWillLeave() {
    return {
        type: actionTypes.TRANSFER_WILL_LEAVE
    };
}

function paymentByChanged(value) {
    return {
        type: actionTypes.TRANSFER_PAYMENT_BY_CHANGED,
        payload: {
            value
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.TRANSFER_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function validateUIStep(data) {
    return {
        type: actionTypes.TRANSFER_VALIDATE_UI_STEP,
        payload: {
            data
        }
    };
}

function resetDatesTransfer (response) {
    if (response) {
        return {
            type: actionTypes.RESET_TRANSFER_DATES,
        }
    }
}

function validateImmediateTransferSuccess(response) {
    return {
        type: actionTypes.TRANSFER_IMMEDIATE_SUCCESS,
        payload: {
            isImmediate: response.banksAdhered,
            amount: response.fee
        }
    }
}

function validateImmediateTransferFetching() {
    return {
        type: actionTypes.TRANSFER_IMMEDIATE_FETCHING,
    }
}

function validateImmediateTransferFailure() {
    return {
        type: actionTypes.TRANSFER_IMMEDIATE_FAILURE,
    }
}

function handleImmediateTransfer(isImmediateTransfer) {
    return {
        type: actionTypes.TRANSFER_DO_IMMEDIATE,
        payload: {
            isImmediateTransfer
        }
    }
}

function showScamWarning(value) {
    return {
        type: actionTypes.TRANSFER_SCAM_WARNING,
        payload: {
            value
        }
    }
}

function limitError(value) {
    return {
        type: actionTypes.TRANSFER_LIMIT_ERROR,
        payload: {
            value
        }
    }
}

const payeeVerificationRequest = () => ({
    type: actionTypes.TRANSFER_PAYEE_VERIFICATION_REQUEST
});

const payeeVerificationSuccess = response => ({
    type: actionTypes.TRANSFER_PAYEE_VERIFICATION_SUCCESS,
    payload: {
        ...response
    }
});

const resetVerificationPayee = () => ({
    type: actionTypes.TRANSFER_PAYEE_VERIFICATION_RESET,
})

const payeeVerificationFailure = () => ({
    type: actionTypes.TRANSFER_PAYEE_VERIFICATION_FAILURE,
})

const resetSelectedWeekDay = () => {
    return {
        type: TRANSFER_RESET_WEEK_DAY
    };
}

const validationRequest = () => ({
    type: actionTypes.TRANSFER_VALIDATE_STEP_REQUEST
});

const validationSuccess = data => ({
    type: actionTypes.TRANSFER_VALIDATE_STEP_SUCCESS,
    payload: {
        code: get(data, 'actuanteBeneficiario.codTipoActuante'),
        number: get(data, 'actuanteBeneficiario.numeroActuante'),
        agentCode: get(data, 'actuanteAgenteFinanciero.codTipoActuante'),
        agentNumber: get(data, 'actuanteAgenteFinanciero.numeroActuante'),
        returnCode: data.codigoRetorno || '',
        operationCode: data.codigoOperacion || '',
        costs: data.comisionesDetalle,
        commissions: data.comisiones,
        shipmentCosts: data.gastosCorreo,
        totalPrice: data.importeAdeudar,
        bicBanco: data.bicBanco,
        fechaValor: data.fechaValor
    }
});

const validationFailure = error => ({
    type: actionTypes.TRANSFER_VALIDATE_STEP_FAILURE,
    payload: {
        error
    }
});

const modalWarningValidate = () => (dispatch) => {
    dispatch(setTermsAndCondsInfo(
        IMMEDIATE_TRANSFER_PRODUCT_ALIAS,
        [{
            "passportProductId": IMMEDIATE_TRANSFER_PRODUCT_ALIAS.toUpperCase()
        }]
    ))
}

const validateImmediateTransfer = (iban, divisa, importe, cuentaOrigenTipoProducto, cuentaOrigenSubtipoProducto) => (dispatch) => {
    const query = {
        query: {
            iban,
            divisa,
            importe,
            cuentaOrigenTipoProducto,
            cuentaOrigenSubtipoProducto
        }
    }
    dispatch(validateImmediateTransferFetching());
    return APIPost(dispatch, apiURLBuilder.getURL('immediateTransfer'), query).then(
        response => {
            dispatch(validateImmediateTransferSuccess(response))
        },
        error => { dispatch(validateImmediateTransferFailure(error)) }
    );
}

const requestScamWarningValidation = (query) => (dispatch)=> {
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('transferLimit'),
        {
            query: query.query,
            isFullResponse: true
        }
    )
        .then(()=>{
            dispatch(setVisibleStep(2))
        })
        .catch((response)=>{
            if(response.error.status === 406) {
                dispatch(showScamWarning(true))
            } else {
                dispatch(limitError(true))
            }
        })
        .finally(()=>{
            dispatch(isFetching(false));
        })

}

const validateWithAPI = () => async (dispatch, getState) => {
    const immTransfer = getState().transfer.getIn(['steps', 0]);
    const immFlagBasedFeatures = getState().flagBasedFeatures;

    const valid = immTransfer.get('valid');

    if (valid) {
        const accountId = immTransfer.get('fromAccount');
        const immAccount = getState().accounts.getIn(['byId', accountId]);

        const beneficiaryType = immTransfer.getIn(['beneficiary', 'type']);

        let immBeneficiary;
        if (beneficiaryType === BENEFICIARY_TYPE_EXISTING) {
            const beneficiaryId = immTransfer.getIn(['beneficiary', 'existing', 'id']);
            immBeneficiary = getState().beneficiaries.getIn(['byId', beneficiaryId]);
        } else {
            immBeneficiary = immTransfer.getIn(['beneficiary', 'new']);
        }

        let requestData = {
            header: {
                version: '2'
            },
            query: {
                contratoOrdenante: {
                    numeroContrato: immAccount.get('newContractNumber'),
                    producto: immAccount.get('newProduct')
                },
                contratoOrdenanteIban: immAccount.get('iban'),
                importe: {
                    importe: immTransfer.get('amount'),
                    divisa: immBeneficiary.get('currency')
                },
                concepto: immTransfer.get('concept'),
                nombreCompletoBeneficiario: immBeneficiary.get('name') || 'nombre', //if beneficiary name comes empty, use a default name as validation requires a non empty string as beneficiary name
                paisTransferencia: immBeneficiary.get('country'),
                localidadBeneficiario: immBeneficiary.get('city') || undefined,
                direccionBeneficiario: immBeneficiary.get('address') || undefined,
                divisaOrd: immAccount.getIn(['balance', 'currency']),
                indicadorResidenciaDestinatario: immTransfer.get('isResident')
            }
        };

        const isSepa = transfersHelper.isSepa(
            immBeneficiary.get('country'),
            immBeneficiary.get('currency')
        );
        const sepaType = transfersHelper.getSepaTypeTransfers(
            immBeneficiary.get('country'),
            immBeneficiary.get('currency'),
            immBeneficiary.get('iban')
        );

        if (sepaType !== SEPA_NATIONAL) {
            //(nicolas.olmos): necessary params to perfom a transfer between spanish accounts in currency different of EURO.
            if (
                immBeneficiary.get('country') === DEFAULT_COUNTRY &&
                immBeneficiary.get('currency') !== EURO_TEXT
            ) {
                requestData.query.indicadorResidenciaDestinatario = 'S';
            } else {
                requestData.query.indicadorResidenciaDestinatario = 'N'; // For SEPA INTERNATIONAL or NO SEPA, the service asks for N here
            }
        }
        if (isSepa) {
            requestData.query.cuentaBeneficiario = immBeneficiary.get('iban').toUpperCase();
        } else {
            const hasToSendBic = immTransfer.get('costs') && ['C', 'O', 'B'].includes(immTransfer.get('costs'));

            requestData.query.ctaVinculada = 'N';
            requestData.query.indicadorGastos = immTransfer.get('costs');
            requestData.query.cuentaBeneficiario = immBeneficiary.get('accountNumber');
            requestData.query.bicBancoBeneficiario = hasToSendBic ? immBeneficiary.get('bic') : '';
            requestData.query.nombreBancoDestino = immBeneficiary.get('bankName') || undefined;
            requestData.query.domicilioBanco = immBeneficiary.get('bankAddress') || undefined;
            requestData.query.localidadBanco = immBeneficiary.get('bankCity') || undefined;
        }

        if (getState().transfer.get('doTransferImmediate')) {
            requestData.query.indUrgencia = 'I';
            requestData.query.indUrgenteSn = 'S';
        }

        // @ date params
        if (immTransfer.get('periodicityEnabled')) {
            requestData.query.tipoTransferencia = 'PERIODICA';
            requestData.query.fechaInicioVigencia = immTransfer.get('date').format(DATE_FORMAT_API);

            if (sepaType === SEPA_INTERNATIONAL) {
                requestData.query.fechaProximaEjecucion = immTransfer.get('date').format(DATE_FORMAT_API); //sepa international need this in validation too
            }

            let rangeCode;
            switch (immTransfer.get('periodicityRange')) {
                case CC_PERIODICITY_DAILY:
                    rangeCode = '101';
                    requestData.query.periodicidades = {
                        "periodicidad": [
                            {
                                "dia": 1,
                                "mes": 0,
                                "tiempo": 1
                            }
                        ]
                    };
                    break;
                case CC_PERIODICITY_WEEKLY:
                    rangeCode = '107';
                    requestData.query.fechaInicioVigencia = transfersHelper.getInitialWeekDayDate(immTransfer.get('date'), immTransfer.get('selectedWeekDay')).format(DATE_FORMAT_API);
                    requestData.query.fechaProximaEjecucion = requestData.query.fechaInicioVigencia;
                    requestData.query.periodicidades = {
                        "periodicidad": [
                            {
                                "dia": immTransfer.get('selectedWeekDay'),
                                "mes": 0,
                                "tiempo": 1
                            }
                        ]
                    };
                    break;
                case PERIODICITY_MONTHLY:
                    rangeCode = '201';
                    if (__CONTACT_CENTER__) {
                        requestData.query.periodicidades = {
                            "periodicidad": [
                                {
                                    "dia": immTransfer.get('date').date(),
                                    "mes": 0,
                                    "tiempo": 1
                                }
                            ]
                        };
                    } else {
                        requestData.query.tiempo = '1';
                    }
                    break;
                case PERIODICITY_QUARTERLY:
                    rangeCode = '203';
                    if (__CONTACT_CENTER__) {
                        requestData.query.periodicidades = {
                            "periodicidad": [
                                {
                                    "dia": immTransfer.get('date').date(),
                                    "mes": 0,
                                    "tiempo": 3
                                }
                            ]
                        };
                    } else {
                        requestData.query.tiempo = '3';
                    }
                    break;
                case PERIODICITY_BIANNUAL:
                    rangeCode = '206';
                    if (__CONTACT_CENTER__) {
                        requestData.query.periodicidades = {
                            "periodicidad": [
                                {
                                    "dia": immTransfer.get('date').date(),
                                    "mes": 0,
                                    "tiempo": 6
                                }
                            ]
                        };
                    } else {
                        requestData.query.tiempo = '6';
                    }
                    break;
                case CC_PERIODICITY_CUSTOM:
                    if (immTransfer.get('periodicityRangeSpecified') === CC_PERIODICITY_RANGE_SPECIFICATION_DAYS) {
                        rangeCode = '200'; // Multiple days, always monthly
                        requestData.query.periodicidades = {
                            "periodicidad": transfersHelper.getCustomPeriodicityArrayFromSelectedMonthDays(immTransfer)
                        };
                    } else {
                        rangeCode = transfersHelper.getPeriodicityCodeFromMonths(parseInt(immTransfer.get('periodicityRangeQuantity'), 10));
                        requestData.query.periodicidades = {
                            "periodicidad": transfersHelper.getCustomPeriodicityArrayFromDate(immTransfer)
                        };
                    }
                    break;
            }

            requestData.query.indicadorPeriodicidad = {
                codigoalfanum3: rangeCode
            };

            requestData.query.periodicidades = {
                periodicidad: [{
                    dia: immTransfer.get('date').date(), //get number of day from date
                    mes: 0,
                    tiempo: 1
                }]
            };

            switch (immTransfer.get('periodicityType')) {
                case PERIODICITY_CONSTANTLY:
                    requestData.query.fechaFinVigencia = '9999-01-01'; // @ this is not hardcoded, use a long date on purpose for type constantly
                    break;
                case PERIODICITY_DATE:
                    requestData.query.fechaFinVigencia = immTransfer
                        .get('periodicityDate')
                        .format(DATE_FORMAT_API);
                    break;
                case PERIODICITY_COUNT:
                    requestData.query.fechaFinVigencia = immTransfer
                        .get('periodicityEstimatedEndDate')
                        .format(DATE_FORMAT_API);
                    break;
            }

            requestData.query.indicadorTratamientoFechaEmis = immTransfer.get(
                'periodicityTreatmentNonWorkableDay'
            );

            if (__CONTACT_CENTER__) {
                if (sepaType === SEPA_NATIONAL) {
                    requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL;
                } else if (sepaType === SEPA_INTERNATIONAL) {
                    requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL;
                }
            }
        } else {
            if (immTransfer.get('isToday')) {
                requestData.query.fechaEmision = immTransfer.get('date').format(DATE_FORMAT_API);
                requestData.query.tipoTransferencia = 'EMISION';

                if (!isSepa) {
                    requestData.query.tipoCuenta = !!immBeneficiary.get('bic') ? 'C' : 'D';
                }

                if (__CONTACT_CENTER__) {
                    if (sepaType === SEPA_NATIONAL) {
                        requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL;
                    } else if (sepaType === SEPA_INTERNATIONAL) {
                        requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY_EMISION_SEPA_INTERNATIONAL : CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL;
                    }
                }
            } else {
                requestData.query.fechaProximaEjecucion = immTransfer
                    .get('date')
                    .format(DATE_FORMAT_API);
                requestData.query.tipoTransferencia = 'DIFERIDA';
                requestData.query.indicadorTratamientoFechaEmis = 'P';

                if (!isSepa) {
                    requestData.query.indicadorTipoEnvioCorreo = '0';
                    requestData.query.indicadorUrgencia = 'N';
                    requestData.query.indicadorDesgloseComisiones = 'N';
                }

                if (__CONTACT_CENTER__) {
                    if (sepaType === SEPA_NATIONAL) {
                        requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL;
                    } else if (sepaType === SEPA_INTERNATIONAL) {
                        requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL;
                    }
                }
            }
        }

        dispatch(validationRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('transferValidation'), requestData)
            .then(response => {
                if(!__CONTACT_CENTER__ && immFlagBasedFeatures.get(TRANSFERS_SECURITY_WARNING)){
                    const scamWarningRequestData = cloneDeep(requestData);
                    scamWarningRequestData
                        .query
                        .contratoOrdenante
                        .numeroContrato = immAccount.get('contractNumber');
                    scamWarningRequestData
                        .query
                        .contratoOrdenante
                        .producto = immAccount.get('product');
                    dispatch(requestScamWarningValidation(scamWarningRequestData));
                    return dispatch(validationSuccess(response))
                } else {
                    dispatch(isFetching(false));
                    dispatch(setVisibleStep(2))
                    return dispatch(validationSuccess(response));
                }
            })
            .catch(response => {
                if (!!response.error) {
                    scrollToTop();

                    if (typeof response.error.description === 'string') {
                        if (getLanguage() === 'es') {
                            if(response.error.description.indexOf('&') > -1) {
                                const regexToScapeAmpersand = new RegExp(/[\w\d.,]+/g);
                                response.body.errorDescription = response.error.description.match(regexToScapeAmpersand).join(' ');
                            }
                        } else {
                            const messagedParsedfromApi = formatTextApi('transferSummary-validationErrorMessage', response.body.error);
                            messagedParsedfromApi === DEFAULT_TRANSLATION_TEXT? response.body.errorDescription = formatText('transferSummary-validationErrorMessage'): response.body.errorDescription = messagedParsedfromApi;
                        }
                    }
                    return dispatch(validationFailure(response.body));
                } else {
                    return dispatch(validationFailure(response.body || response))
                }
            });
    } else {
        scrollToTop();
    }
};

const validateStep = (step, flag=true ) => dispatch => {

    if(flag)
    {
        dispatch(validateUIStep(step));
        dispatch(validateWithAPI());
    }
    else {
        dispatch(validateUIStep(step));
    }

};

const transferRequest = () => ({
    type: actionTypes.TRANSFER_REQUEST_TRANSFER_REQUEST
});

const transferSuccess = data => ({
    type: actionTypes.TRANSFER_REQUEST_TRANSFER_SUCCESS,
    payload: {
        referenceNumber: trim(data.referencia),
        mailError: data.mailError || ''
    }
});

const transferEditSuccess = data => ({
    type: actionTypes.TRANSFER_REQUEST_TRANSFER_SUCCESS,
    payload: {
        referenceNumber: trim(data.referencia),
        mailError: data.mailError || ''
    }
});

const transferCharitySuccess = data => ({
    type: actionTypes.TRANSFER_REQUEST_TRANSFER_SUCCESS,
    payload: {
        referenceNumber: trim(data.referencia),
        mailError: data.mailError || ''
    }
});

const transferFailure = data => ({
    type: actionTypes.TRANSFER_REQUEST_TRANSFER_FAILURE,
    payload: {
        error: get(data, 'body.error', '') === 'PL_5183' ? 'PL_5183' : get(data, 'body.error', UNEXPECTED_ERROR),
        errorDescription: get(data, 'body.errorDescription', '')
    }
});

const transferEditFailure = data => ({
    type: actionTypes.TRANSFER_REQUEST_EDIT_TRANSFER_FAILURE,
    payload: {
        error: get(data, 'body.error', '') === 'PL_5183' ? 'PL_5183' : get(data, 'body.error', UNEXPECTED_ERROR),
        errorDescription: get(data, 'body.errorDescription', '')
    }
});

const transferCharityFailure = data => ({
    type: actionTypes.TRANSFER_REQUEST_CHARITY_TRANSFER_FAILURE,
    payload: {
        error: get(data, 'body.error', '') === 'PL_5183' ? 'PL_5183' : get(data, 'body.error', UNEXPECTED_ERROR),
        errorDescription: get(data, 'body.errorDescription', '')
    }
});


const transferEditBeneficiarySuccess = () => ({
    type: actionTypes.TRANSFER_EDIT_BENEFICIARY_SUCCESS
});

const transferAddBeneficiarySuccess = () => ({
    type: actionTypes.TRANSFER_ADD_BENEFICIARY_SUCCESS
});

const postTransfer = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immProfile = getState().profile;
        const immTransfer = getState().transfer.getIn(['steps', 0]);
        const immExtra = getState().transfer.get('extra');
        const accountId = immTransfer.get('fromAccount');
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const beneficiaryType = immTransfer.getIn(['beneficiary', 'type']);

        let immBeneficiary;
        if (beneficiaryType === BENEFICIARY_TYPE_EXISTING) {
            const beneficiaryId = immTransfer.getIn(['beneficiary', 'existing', 'id']);
            immBeneficiary = getState().beneficiaries.getIn(['byId', beneficiaryId]);
        } else {
            immBeneficiary = immTransfer.getIn(['beneficiary', 'new']);
        }

        const sepaType = transfersHelper.getSepaTypeTransfers(
            immBeneficiary.get('country'),
            immBeneficiary.get('currency'),
            immBeneficiary.get('iban')
        );
        let requestData = {
            header: {
                version: '2'
            },
            query: {
                dataToken: dataToken,
                actuanteBeneficiario: {
                    codTipoActuante: immExtra.get('confirmationCode'),
                    numeroActuante: immExtra.get('confirmationNumber')
                },
                contratoOrdenante: {
                    numerodecontrato: immAccount.get('newContractNumber'),
                    producto: immAccount.get('newProduct')
                },
                codIbanOrdenante: immAccount.get('iban'),
                importe: {
                    importe: immTransfer.get('amount'),
                    divisa: immBeneficiary.get('currency')
                },
                divisaOrdenante: immAccount.getIn(['balance', 'currency']),
                concepto: immTransfer.get('concept'),
                tipoSepa: sepaType,
                indResidenteBeneficiario: immTransfer.get('isResident'),
                nombreCompletoBeneficiario: immBeneficiary.get('name'),
                pais: immBeneficiary.get('country'),
                nombrePrimerTitular: !!immTransfer.get('emitter') ? immAccount.get('accountHolder') : immProfile.get('nombreCompleto'),
                email: immTransfer.getIn(['beneficiary', 'email', 'value']),
                sendEmail: immTransfer.get('isToday') && !immTransfer.get('periodicityEnabled')
                /*saldoActual: { //not needed
                    divisa: immAccount.getIn(['balance', 'currency']),
                    importe: immAccount.getIn(['balance', 'amount'])
                }*/
                /*localidadBeneficiario: immBeneficiary.get('city') || undefined, // key missing in confirmation endpoint
                direccionBenef: {
                    detalledomicilio: immBeneficiary.get('address') || undefined, // not sure
                    formatodomicilio: "string" // neither
                },*/
           }
        };

        if (!!immTransfer.get('emitter')) {
            const emitterValues = immTransfer.get('emitter').split(HYPHEN);
            requestData.query.personaTitular = {
                codigodepersona: parseInt(emitterValues[1]),
                tipodepersona: emitterValues[0]
            };
        }

        if (sepaType !== SEPA_NATIONAL) {
            //(nicolas.olmos): necessary params to perfom a transfer between spanish accounts in currency different of EURO.
            if (
                immBeneficiary.get('country') === DEFAULT_COUNTRY &&
                immBeneficiary.get('currency') !== EURO_TEXT
            ) {
                requestData.query.indicadorResidenciaDestinatario = 'S';
            } else {
                requestData.query.indResidenteBeneficiario = 'N'; // For SEPA INTERNATIONAL or NO SEPA, the service asks for N here
            }
        }

        const isSepa = transfersHelper.isSepa(
            immBeneficiary.get('country'),
            immBeneficiary.get('currency')
        );
        if (isSepa) {
            requestData.query.cuentaIbanBeneficiario = immBeneficiary.get('iban').toUpperCase();
            //Se informa el Bic que devuelve el servicio de validacion para los casos de sepa internacinoal
            if (sepaType === 'SI') {
                requestData.query.bicBancoBeneficiario = immExtra.get('bicBanco');
            }
        } else {
            requestData.query.cuentaIbanBeneficiario = immBeneficiary.get('accountNumber');
            requestData.query.bicBancoBeneficiario = immBeneficiary.get('bic') || undefined;
            requestData.query.nombreBancoIbanBeneficiario =
                immBeneficiary.get('bankName') || undefined;
            requestData.query.codOperacion = 'EX';
            requestData.query.ctaVinculada = 'N';
            requestData.query.indGastos = immTransfer.get('costs');

            if (immBeneficiary.get('bankAddress') || immBeneficiary.get('bankCity')) {
                requestData.query.datosSwift = {
                    //bicBancoBeneficiario: immBeneficiary.get('bic') || undefined, // repeated??
                    //nombreBancoDestino: immBeneficiary.get('bankName') || undefined, // repeated??
                    //cuentaBeneficiarioNoSepa: immBeneficiary.get('accountNumber') || undefined, // repeated??
                    domicilioBanco: immBeneficiary.get('bankAddress') || undefined,
                    localidadBanco: immBeneficiary.get('bankCity') || undefined
                    //nombrepaisBanco: "string",
                    //paisBanco: "string"
                };
            }
        }

        if (getState().transfer.get('doTransferImmediate')) {
            requestData.query.indUrgencia = 'I';
            requestData.query.indUrgenteSn = 'S';
        }

        if (immTransfer.get('periodicityEnabled')) {
            requestData.query.tipoTransferencia = 'PERIODICA';
            requestData.query.fechaInicioVigencia = immTransfer.get('date').format(DATE_FORMAT_API);
            requestData.query.fechaProximaEjecucion = immTransfer.get('date').format(DATE_FORMAT_API);

            let rangeCode;
            switch (immTransfer.get('periodicityRange')) {
                case CC_PERIODICITY_DAILY:
                    rangeCode = '101';
                    requestData.query.periodicidades = {
                        "periodicidad": [
                            {
                                "dia": 1,
                                "mes": 0,
                                "tiempo": 1
                            }
                        ]
                    };
                    break;
                case CC_PERIODICITY_WEEKLY:
                    rangeCode = '107';
                    requestData.query.fechaInicioVigencia = transfersHelper.getInitialWeekDayDate(immTransfer.get('date'), immTransfer.get('selectedWeekDay')).format(DATE_FORMAT_API);
                    requestData.query.fechaProximaEjecucion = requestData.query.fechaInicioVigencia;
                    requestData.query.periodicidades = {
                        "periodicidad": [
                            {
                                "dia": immTransfer.get('selectedWeekDay'),
                                "mes": 0,
                                "tiempo": 1
                            }
                        ]
                    };
                    break;
                case PERIODICITY_MONTHLY:
                    rangeCode = '201';
                    if (__CONTACT_CENTER__) {
                        requestData.query.periodicidades = {
                            "periodicidad": [
                                {
                                    "dia": immTransfer.get('date').date(),
                                    "mes": 0,
                                    "tiempo": 1
                                }
                            ]
                        };
                    }
                    break;
                case PERIODICITY_QUARTERLY:
                    rangeCode = '203';
                    if (__CONTACT_CENTER__) {
                        requestData.query.periodicidades = {
                            "periodicidad": [
                                {
                                    "dia": immTransfer.get('date').date(),
                                    "mes": 0,
                                    "tiempo": 3
                                }
                            ]
                        };
                    }
                    break;
                case PERIODICITY_BIANNUAL:
                    rangeCode = '206';
                    if (__CONTACT_CENTER__) {
                        requestData.query.periodicidades = {
                            "periodicidad": [
                                {
                                    "dia": immTransfer.get('date').date(),
                                    "mes": 0,
                                    "tiempo": 6
                                }
                            ]
                        };
                    }
                    break;

                case CC_PERIODICITY_CUSTOM:
                if (immTransfer.get('periodicityRangeSpecified') === CC_PERIODICITY_RANGE_SPECIFICATION_DAYS) {
                    rangeCode = '200'; // Multiple days, always monthly
                    requestData.query.periodicidades = {
                        "periodicidad": transfersHelper.getCustomPeriodicityArrayFromSelectedMonthDays(immTransfer)
                    };
                } else {
                    rangeCode = transfersHelper.getPeriodicityCodeFromMonths(parseInt(immTransfer.get('periodicityRangeQuantity'), 10));
                    requestData.query.periodicidades = {
                        "periodicidad": transfersHelper.getCustomPeriodicityArrayFromDate(immTransfer)
                    };
                }
                break;
            }

            requestData.query.indicadorPeriodicidad = {
                codigoalfanum3: rangeCode
            };

            requestData.query.periodicidades = {
                periodicidad: [{
                    dia: immTransfer.get('date').date(), //get number of day from date
                    mes: 0,
                    tiempo: 1
                }]
            };

            switch (immTransfer.get('periodicityType')) {
                case PERIODICITY_CONSTANTLY:
                    requestData.query.fechaFinVigencia = '9999-01-01'; // @ this is not hardcoded, use a long date on purpose for type constantly
                    break;
                case PERIODICITY_DATE:
                    requestData.query.fechaFinVigencia = immTransfer
                        .get('periodicityDate')
                        .format(DATE_FORMAT_API);
                    break;
                case PERIODICITY_COUNT:
                    requestData.query.fechaFinVigencia = immTransfer
                        .get('periodicityEstimatedEndDate')
                        .format(DATE_FORMAT_API);
                    break;
            }

            requestData.query.indTratamientoFechaEmis = immTransfer.get(
                'periodicityTreatmentNonWorkableDay'
            );

            if (__CONTACT_CENTER__) {
                if (sepaType === SEPA_NATIONAL) {
                    requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL;
                } else if (sepaType === SEPA_INTERNATIONAL) {
                    requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL;
                }
            }
        } else {
            if (immTransfer.get('isToday')) {
                requestData.query.fechaEmision = !!immExtra.get('newValidDateWhenItWillBeDone')? immExtra.get('newValidDateWhenItWillBeDone') : immTransfer.get('date').format(DATE_FORMAT_API);
                requestData.query.tipoTransferencia = 'EMISION';

                if (!isSepa) {
                    requestData.query.tipoCuenta = !!immBeneficiary.get('bic') ? 'C' : 'D';
                    requestData.query.actuanteAgenteFinanciero = {
                        numerodeactuante: immExtra.get('agentConfirmationNumber'),
                        tipodeactuante: {
                            codtipodeactuante: immExtra.get('agentConfirmationCode'),
                            empresa: API_ENTERPRISE_NUMBER
                        }
                    };

                    //O (Ordenante) B (Beneficiario) S (Shared Compartido)
                    requestData.query.tipoGastosPago = {
                        codigoalfanum: immTransfer.get('costs') === TRANSFER_COSTS_SHARED ? 'S' : immTransfer.get('costs')
                    };
                }

                if (__CONTACT_CENTER__) {
                    if (sepaType === SEPA_NATIONAL) {
                        requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL;
                    } else if (sepaType === SEPA_INTERNATIONAL) {
                        requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY_EMISION_SEPA_INTERNATIONAL : CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL;
                    }
                }
            } else {
                requestData.query.fechaProximaEjecucion = immTransfer
                    .get('date')
                    .format(DATE_FORMAT_API);
                requestData.query.tipoTransferencia = 'DIFERIDA';
                requestData.query.indTratamientoFechaEmis = 'P';

                if (sepaType === SEPA_NATIONAL) {
                    requestData.query.tipoOperacion = {
                        indtipoperacion: '10',
                        naturalezapagomispag: {
                            codalfanum: '10'
                        }
                    };
                }

                if (sepaType === NONE_SEPA) {
                    requestData.query.datosSwift = {
                        bicBancoBeneficiario: immBeneficiary.get('bic') || undefined, // repeated??
                        nombreBancoDestino: immBeneficiary.get('bankName') || undefined, // repeated??
                        domicilioBanco: immBeneficiary.get('bankAddress') || undefined,
                        localidadBanco: immBeneficiary.get('bankCity') || undefined,
                        paisBanco: immBeneficiary.get('country')
                    };
                }

                if (__CONTACT_CENTER__) {
                    if (sepaType === SEPA_NATIONAL) {
                        const transferTypeCode = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_NATIONAL;

                        requestData.query.indTipoOperacion = transferTypeCode;
                        requestData.query.tipoOperacion.indtipoperacion = transferTypeCode; // Overrides indtipoperacion because both indTipoOperacion and indtipoperacion have to be equal
                    } else if (sepaType === SEPA_INTERNATIONAL) {
                        requestData.query.indTipoOperacion = (immTransfer.get('transferType') === CC_TRANSFER_TYPE_ORDINARY) ? CC_TRANSFER_TYPE_CODE_ORDINARY : CC_TRANSFER_TYPE_CODE_PAYROLL_SEPA_INTERNATIONAL;
                    }
                }
            }
        }
        requestData.query.context = getWidgetData();
        requestData.query.nuDataSession = getSessionId();
        dispatch(transferRequest());

        const isOrdinaryTransfer = beneficiaryType === BENEFICIARY_TYPE_NGO

        return APIPost(dispatch, apiURLBuilder.getURL('transferConfirmation'), requestData)
            .then(response => {
                if ((beneficiaryType === BENEFICIARY_TYPE_NEW
                    ||
                    beneficiaryType === BENEFICIARY_TYPE_NGO)
                    &&
                    !immTransfer.get('isReusingTransfer')
                    &&
                    !immTransfer.get('isEditingScheduled')) {

                    const transferAction = isOrdinaryTransfer
                        ? transferSuccess
                        : transferCharitySuccess

                    if (immBeneficiary.get('isEditingBeneficiaryExisting')) {
                        const beneficiaryExistingId = getState().transfer.getIn(['steps', 0, 'beneficiary', 'existing', 'id']);
                        const immBeneficiaryExisting = getState().beneficiaries.getIn(['byId', beneficiaryExistingId]);

                        const sepaTypeBeforeEdit = transfersHelper.getSepaTypeTransfers(
                            immBeneficiaryExisting.get('country'),
                            immBeneficiaryExisting.get('currency'),
                            immBeneficiaryExisting.get('iban')
                        );

                        dispatch(addBeneficiaryActions.editBeneficiaryFromTransferForm(dataToken, sepaTypeBeforeEdit, beneficiaryExistingId))
                            .then(() => {
                                dispatch(transferAction(response));
                                dispatch(transferEditBeneficiarySuccess());
                                dispatch(addBeneficiaryActions.reset());
                            }).catch(() => {
                                dispatch(transferAction(response));
                                dispatch(addBeneficiaryActions.reset());
                            })
                    } else if ((immBeneficiary.get('addBeneficiary'))) {
                        dispatch(addBeneficiaryActions.addBeneficiaryFromTransferForm(dataToken))
                            .then(() => {
                                dispatch(transferAction(response));
                                dispatch(transferAddBeneficiarySuccess());
                                dispatch(addBeneficiaryActions.reset());
                            }).catch(() => {
                                dispatch(transferAction(response));
                                dispatch(addBeneficiaryActions.reset());
                            })
                    } else {
                        dispatch(transferAction(response));
                    }
                } else {
                    dispatch(transferSuccess(response));
                }
            }).catch(response => {
                if (!!response.error) {
                    const transferFailureAction = isOrdinaryTransfer
                        ? transferFailure
                        : transferCharityFailure
                    dispatch(transferFailureAction(response));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

function toggleIbanModal() {
    return {
        type: actionTypes.TOGGLE_IBAN_MODAL
    };
}

function setAllTransferFields(fields) {
    return {
        type: actionTypes.TRANSFER_SET_ALL_FIELDS,
        payload: {
            fields
        }
    };
}

const buildTransferFields = (accountId, transferId) => (dispatch, getState) => {
    const immEmitedTransfer = getState().emitedTransfers.getIn([accountId, 'byId', transferId]);
    const immEmitedTransferDetails = immEmitedTransfer.get('details');
    const currency = immEmitedTransferDetails.getIn(['amount', 'currency']);
    const oldEmitter = `${immEmitedTransfer.getIn(['emitter','type'])}${HYPHEN}${immEmitedTransfer.getIn(['emitter','code'])}`;
    const newBeneficiary = {};
    let costs = TRANSFER_COSTS_SHARED;

    if (immEmitedTransferDetails) {
        const country = immEmitedTransfer.get('country');
        const isResident =
            country === DEFAULT_COUNTRY ? BENEFICIARY_IS_RESIDENT : BENEFICIARY_IS_NOT_RESIDENT;
        const isSepa = transfersHelper.isSepa(country, currency);
        const bic = immEmitedTransferDetails.get('bic');
        const iban = immEmitedTransferDetails.get('abonoIban') || immEmitedTransferDetails.get('accountNumber');

        if (isSepa) {
            if (!!iban) {
                newBeneficiary.iban = iban;
                newBeneficiary.ibanIsDirty = true;
                newBeneficiary.ibanIsValid = true;
            }
        } else {
            newBeneficiary.accountNumber = immEmitedTransferDetails.get('accountNumber');
            newBeneficiary.accountNumberIsValid = !!immEmitedTransferDetails.get('accountNumber');
            newBeneficiary.accountNumberIsDirty = true;
            const transferExpenses = immEmitedTransferDetails.get('transferExpenses');
            if (transferExpenses === TRANSFER_COSTS_SENDER_TEXT) {
                costs = TRANSFER_COSTS_SENDER;
            } else if (transferExpenses === TRANSFER_COSTS_BENEFICIARY_TEXT) {
                costs = TRANSFER_COSTS_BENEFICIARY;
            }

            if (!bic) {
                newBeneficiary.bankOption = BENEFICIARY_BANK_OPTION_NAME;
                newBeneficiary.bankName = immEmitedTransferDetails.get('receiverBank');
                newBeneficiary.bankCity = immEmitedTransferDetails.get('receiverBankCity');
                newBeneficiary.bankAddress = immEmitedTransferDetails.get('receiverBankAddress');
            } else {
                newBeneficiary.bic = bic;
                newBeneficiary.bicIsDirty = true;
                newBeneficiary.bicIsValid = true;
            }
        }

        newBeneficiary.currency = currency;
        newBeneficiary.isResident = isResident;
        newBeneficiary.country = country;
        newBeneficiary.address = trim(immEmitedTransferDetails.get('beneficiaryAddress'));
        newBeneficiary.name = trim(immEmitedTransferDetails.get('beneficiary'));
        newBeneficiary.city = immEmitedTransferDetails.get('beneficiaryCity');
    }

    return {
        costs,
        oldEmitter,
        isReusingTransfer: true,
        amount: immEmitedTransfer.getIn(['amount', 'amount']),
        concept: trim(immEmitedTransfer.get('concept')),
        beneficiary: {
            new: newBeneficiary
        }
    };
};

const generateBic = (transferIssuerDetails) => {
    const codSwift = transferIssuerDetails.codSwift;
    const centroMsjSwift = transferIssuerDetails.centroMsjSwift;

    if (codSwift && centroMsjSwift) {
        return `${centroMsjSwift.empresa}${centroMsjSwift.centro}${codSwift}`;
    }

    return '';
}

const getAccountIban = (account) => {
    return !!account ? trim(`${account.pais}${account.digitodecontrol}${account.codbban}`) : '';
}

const buildEmitedTransferFields = (response) => {
    const transferDetails = response.transferDetails || {};
    const titular = response.transferIssuerDetails.find(titular => titular.interventionType === INTERVENER_TYPE_TITULAR);
    const newBeneficiary = {};
    const currency = get(transferDetails, 'importe.divisa');
    const country = get(transferDetails, 'ctaAbonoIban.pais') || 'ES';
    const isResident = country === DEFAULT_COUNTRY ? BENEFICIARY_IS_RESIDENT : BENEFICIARY_IS_NOT_RESIDENT;
    const isSepa = transfersHelper.isSepa(country, currency);
    const bic = generateBic(transferDetails);
    const accountNumber = trim(transferDetails.descCtaAbono);
    const ctaIban = getAccountIban(transferDetails.ctaAbonoIban);
    const iban = ctaIban || accountNumber;
    let costs = TRANSFER_COSTS_SHARED;
    let emitterType, emitterCode;
    if (!!titular) {
        emitterType = titular.personType;
        emitterCode = titular.personCode;
    }
    const oldEmitter = `${emitterType}${HYPHEN}${emitterCode}`;
    if (isSepa) {
        if (!!iban) {
            newBeneficiary.iban = iban;
            newBeneficiary.ibanIsDirty = true;
            newBeneficiary.ibanIsValid = true;
        }
    } else {
        newBeneficiary.accountNumber = accountNumber;
        newBeneficiary.accountNumberIsValid = !!accountNumber;
        newBeneficiary.accountNumberIsDirty = true;
        const transferExpenses = transferDetails.tradGastosPorCuenta;
        if (transferExpenses === TRANSFER_COSTS_SENDER_TEXT) {
            costs = TRANSFER_COSTS_SENDER;
        } else if (transferExpenses === TRANSFER_COSTS_BENEFICIARY_TEXT) {
            costs = TRANSFER_COSTS_BENEFICIARY;
        }
        if (!bic) {
            newBeneficiary.bankOption = BENEFICIARY_BANK_OPTION_NAME;
            newBeneficiary.bankName = transferDetails.bancoBeneficiario;
            newBeneficiary.bankCity = transferDetails.localidadBancoBeneficiario;
            newBeneficiary.bankAddress = transferDetails.domicilioBanco;
        } else {
            newBeneficiary.bic = bic;
            newBeneficiary.bicIsDirty = true;
            newBeneficiary.bicIsValid = true;
        }
    }
    newBeneficiary.currency = currency;
    newBeneficiary.isResident = isResident;
    newBeneficiary.country = country;
    newBeneficiary.address = trim(transferDetails.domicilioBenef);
    newBeneficiary.name = trim(transferDetails.nombreBeneficiario);
    newBeneficiary.city = transferDetails.localidadBeneficiario;

    let conceptText = transferDetails.concepto|| '';
    conceptText += transferDetails.conceptoDos || '';
    conceptText += transferDetails.conceptoTres || '';
    conceptText += transferDetails.conceptoCuatro || '';

    return {
        costs,
        oldEmitter,
        isReusingTransfer: true,
        amount: get(transferDetails, 'importe.importe'),
        concept: trim(conceptText),
        beneficiary: {
            new: newBeneficiary
        }
    };
}

const reuseMovementTransfer = (accountId, transferId) => (dispatch, getState) => {
    dispatch(handleBeneficiaryType(BENEFICIARY_TYPE_NEW));
    const immAccount = getState().accounts.getIn(['byId',  accountId]);
    const immMovement = getState().accountsTransactions.getIn([accountId, 'byId', transferId]);
    const requestData = {
        header: {
            version: 2
        },
        query: {
            cnuevo: {
                numeroContrato: immAccount.get('newContractNumber'),
                producto: immAccount.get('newProduct')
            },
            cviejo: {
                numerodecontrato: immAccount.get('contractNumber'),
                subgrupo: immAccount.get('product')
            },
            transferDate: immMovement.get('date'),
            transferReferenceNumber: immMovement.get('contractNumber')
        }
    }

    return APIPost({
        dispatch,
        endpoint: 'reuseTransfer',
        params: requestData
    })
    .then(response => {
        const fields = buildEmitedTransferFields(response);
        dispatch(setAllTransferFields(fields));
    });
}

const reuseEmitedTransfer = (accountId, transferId) => (dispatch, getState) => {
    dispatch(handleBeneficiaryType(BENEFICIARY_TYPE_NEW));

    let immEmitedTransfer = getState().emitedTransfers.getIn([accountId, 'byId', transferId]);

    if (immEmitedTransfer) {
        if (immEmitedTransfer.get('details')) {
            const fields = dispatch(buildTransferFields(accountId, transferId));
            return dispatch(setAllTransferFields(fields));
        } else {
            return dispatch(requestEmitedTransfersDetails(immEmitedTransfer))
                .then(() => dispatch(buildTransferFields(accountId, transferId)))
                .then(fields => dispatch(setAllTransferFields(fields)));
        }
    }
};

const handleFetchBeneficiaries = () => (dispatch, getState) => {
    dispatch(requestBeneficiaries()).then(() => {
        const beneficiariesLength = getState().beneficiaries.get('byOrder').size;
        const beneficiaryType = getState().transfer.getIn(['steps', 0, 'beneficiary', 'type']);

        if (beneficiariesLength === 0 && beneficiaryType !== BENEFICIARY_TYPE_NEW) {
            dispatch(handleBeneficiaryType(BENEFICIARY_TYPE_NEW));
        }
    });
};

const handleEditBeneficiary = () => (dispatch, getState) => {
    const beneficiaryId = getState().transfer.getIn(['steps', 0, 'beneficiary', 'existing', 'id']);
    const immBeneficiary = getState().beneficiaries.get('byId').get(beneficiaryId);

    dispatch({
        type: actionTypes.TRANSFER_BENEFICIARY_FILL_EDIT_FORM,
        payload: {
            name: immBeneficiary.get('name'),
            alias: immBeneficiary.get('alias'),
            iban: immBeneficiary.get('iban'),
            accountNumber: immBeneficiary.get('accountNumber'),
            bic: immBeneficiary.get('bic'),
            address: immBeneficiary.get('address'),
            city: immBeneficiary.get('city'),
            currency: immBeneficiary.get('currency'),
            country: immBeneficiary.get('country'),
            bankName: immBeneficiary.get('bankName'),
            bankAddress: immBeneficiary.get('bankAddress'),
            bankCity: immBeneficiary.get('bankCity')
        }
    })
};

const handleCancelEditBeneficiary = () => (dispatch, getState) => {
    const beneficiaryId = getState().transfer.getIn(['steps', 0, 'beneficiary', 'existing', 'id']);

    dispatch({
        type: actionTypes.TRANSFER_BENEFICIARY_CANCEL_EDIT_FORM,
        payload: {
            beneficiaryId
        }
    })
};

function resetImmediateTransfer(){
    return {
        type: actionTypes.RESET_IMMEDIATE_TRANSFER
    };
}

const setProductOffersFetching = () => ({
    type: actionTypes.SET_PRODUCT_OFFERS_REQUEST,
});

const setProductOffersSuccess = response => ({
    type: actionTypes.SET_PRODUCT_OFFERS_SUCCESS,
    payload: {
        response
    }
});

const setProductOffersFailure = () => ({
    type: actionTypes.SET_PRODUCT_OFFERS_FAILURE,
});

const resetProductOffers = () => ({
    type: actionTypes.RESET_PRODUCT_OFFERS,
})

const getPayeeVerification = (params) => (dispatch) => {
    dispatch(payeeVerificationRequest())
    return APIPostMb(dispatch, apiURLBuilder.getModelURL('payeeVerification'), { query: params })
        .then(response => {
            dispatch(payeeVerificationSuccess(response));
        })
        .catch(error => {
            dispatch(payeeVerificationFailure());
        });
}

const getProductOffers = ({depositType, amountTransfer, bank, iban, beneficiaryCurrency, beneficiaryCountry, isNGOBeneficiaryType}) => (dispatch) => {
    dispatch(setProductOffersFetching());
    const isSepa = transfersHelper.isSepa(beneficiaryCountry, beneficiaryCurrency);
    const transferType = isNGOBeneficiaryType ? 'SOLIDARIA' : isSepa ? 'SEPA' : 'NO_SEPA';
    const requestData = {
        depositType,
        amount: amountTransfer,
        bankId: bank,
        iban: iban,
        currency: beneficiaryCurrency,
        transferType
    };
    return APIGet(dispatch, apiURLBuilder.getURL('activeDeposits', {depositIdentifier: ''}), {query: requestData})
        .then(response => {
            dispatch(setProductOffersSuccess(response));
        })
        .catch(response => {
            if (response.error) {
                dispatch(setProductOffersFailure());
            } else {
                throw response;
            }
        });
};

const setRedirectionAccountState = (state) => ({
    type: actionTypes.SET_REDIRECTION_ACCOUNT_STATE,
    payload: {
        state
    }
});

module.exports = {
    accountLimitModalToggle,
    getProductOffers,
    resetSelectedWeekDay,
    handleAddBeneficiary,
    handleBeneficiaryBankOption,
    handleBeneficiaryCountry,
    handleBeneficiaryType,
    handleCancelEditBeneficiary,
    handleChangeTransferType,
    handleCurrency,
    handleEditBeneficiary,
    handleFetchBeneficiaries,
    handlePeriodicityCount,
    handlePeriodicityDate,
    handlePeriodicityEnabled,
    handlePeriodicityRange,
    handlePeriodicityType,
    handleSetNGOValidity,
    handleTransferCostsChange,
    handleTreatmentNonWorkableDay,
    loadOldEmitter,
    paymentByChanged,
    postTransfer,
    reset,
    reuseEmitedTransfer,
    reuseMovementTransfer,
    setAmount,
    setBeneficiary,
    setBeneficiaryAccountNumber,
    setBeneficiaryAddress,
    setBeneficiaryAlias,
    setBeneficiaryBankAddress,
    setBeneficiaryBankCity,
    setBeneficiaryBankName,
    setBeneficiaryBic,
    setBeneficiaryCity,
    setBeneficiaryIban,
    setBeneficiaryName,
    setConcept,
    setDate,
    setEmailNotification,
    setEmitter,
    setFromAccount,
    setIbanOnCountryChange,
    setRedirectionAccountState,
    setVisibleStep,
    setWeekDay,
    addCustomizedMonthDay,
    removeCustomizedMonthDay,
    resetImmediateTransfer,
    setCustomSelectedMonthDay,
    setPeriodicityRangeQuantity,
    setPeriodicityRangeDescription,
    setPeriodicityRangeSpecification,
    setWillCancel,
    setWillLeave,
    toggleIbanModal,
    handleImmediateTransfer,
    setNotDeductibleNGOMessage,
    validateImmediateTransfer,
    modalWarningValidate,
    requestScamWarningValidation,
    resetDatesTransfer,
    showScamWarning,
    resetProductOffers,
    transferFailure, // use in scheduledTransfers actions
    transferRequest, // use in scheduledTransfers actions
    transferSuccess, // use in scheduledTransfers actions
    transferEditSuccess, // use in scheduledTransfers actions
    transferEditFailure, // use in scheduledTransfers actions
    validateStep,
    validateUIStep, // use in scheduledTransfers actions
    validationFailure, // use in scheduledTransfers actions
    validationRequest, // use in scheduledTransfers actions
    validationSuccess, // use in scheduledTransfers actions
    isFetching,
    getPayeeVerification,
    resetVerificationPayee,
};
